import { NAV_STATES } from "../../system/constants";

const initialState = NAV_STATES.HIDE;

const navReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SHOW_NAV": {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default navReducer;
